import React, { useState } from 'react';
import styled from 'styled-components';
import Select from '../select/dropdown';

const Companies = ({
  className,
  companies,
  withDepartments,
  rawOnChange,
  label,
  required,
}) => {
  const [companyValue, setCompanyValue] = useState('');
  const [departmentValue, setDepartmentValue] = useState('');
  const values = (companies || []).map(({ strapiId, documentId, name }) => ({
    value: documentId || strapiId,
    label: name,
  }));
  const currentComp = companies.find(({
    strapiId,
    documentId,
  }) => String(documentId || strapiId) === String(companyValue));
  const departments = currentComp?.departments?.map(({ name }) => ({
    value: name,
  }));
  return (
    <>
      <Select
        className={className}
        values={values}
        onChange={(e) => {
          rawOnChange('toCompany')(e);
          setCompanyValue(e.target.value);
        }}
        value={companyValue}
        label={label}
        required={required ?? false}
        name="toCompany"
        defaultOptionTitle={`Kies een ${label?.toLowerCase() || 'vestiging'}...`}
        alwaysShowDefaultOption
      />
      {withDepartments && (
        <Select
          className={className}
          values={departments}
          onChange={(e) => {
            rawOnChange('toCompanyDepartment')(e);
            setDepartmentValue(e.target.value);
          }}
          value={departmentValue}
          label={withDepartments.label}
          required={withDepartments.required ?? false}
          name="toCompanyDepartment"
          defaultOptionTitle={
            companyValue
              ? `Kies een ${withDepartments.label?.toLowerCase() || 'afdeling'}...`
              : `Kies eerst een ${label?.toLowerCase() || 'vestiging'}...`
          }
          alwaysShowDefaultOption
        />
      )}
    </>
  );
};

export default styled(Companies)``;
